import _JSXStyle from "styled-jsx/style";
import { spacers } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
import { NoticeBoxMessage } from './notice-box-message.js';
import { NoticeBoxTitle } from './notice-box-title.js';
export const NoticeBoxContent = _ref => {
  let {
    children,
    dataTest,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["403435427", [spacers.dp8]]])
  }, /*#__PURE__*/React.createElement(NoticeBoxTitle, {
    title: title,
    dataTest: "".concat(dataTest, "-title")
  }), /*#__PURE__*/React.createElement(NoticeBoxMessage, {
    dataTest: "".concat(dataTest, "-message")
  }, children), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "403435427",
    dynamic: [spacers.dp8]
  }, ["div.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;gap:".concat(spacers.dp8, ";padding-block-start:3px;}")]));
};
NoticeBoxContent.defaultProps = {
  dataTest: 'dhis2-uicore-noticebox-content'
};
NoticeBoxContent.propTypes = {
  children: PropTypes.node,
  dataTest: PropTypes.string,
  title: PropTypes.string
};